import { render } from "./Home.vue?vue&type=template&id=f73e7c04&scoped=true&bindings={\"dpi\":\"props\",\"device\":\"props\",\"setScreenText\":\"options\",\"setFullScreen\":\"options\",\"screenText\":\"setup\",\"fullScreen\":\"setup\"}"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"

import "./Home.vue?vue&type=style&index=0&id=f73e7c04&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-f73e7c04"

export default script